import { ShippingServiceType } from '@/Enums';
import { OrderAutomatizationPackageModel } from '@/Models/OrderUserProducts/OrderAutomatizationPackageModel';
import { genLogisticTypesUtils } from '@/Redux/DynamicData/GenLogisticTypesData/utils';
import { RootState } from '@/Redux/RootReducer';
import { Nullable } from '@/Types';
import { ObjectUtils } from '@/Utils';

export function getShippingServiceName(type: Nullable<ShippingServiceType>, state: RootState): string {
  if (type === null) {
    return '';
  }
  const name = type;
  const enums = state.global.translation.Enums.LogisticShippingServiceType;
  return ObjectUtils.getObjectPathValue(enums, name) || name;
}

export function fillProductsLocalization(x: OrderAutomatizationPackageModel[], state: RootState) {
  x.forEach((p) => {
    p.products.forEach((y) => {
      const logisticName = genLogisticTypesUtils.getLocalizationNameByName(y.logisticTypeName, state);
      const productTypeName = genLogisticTypesUtils.getLocalizationNameByName(y.productTypeName, state);
      const shippingServiceName = getShippingServiceName(y.shippingServiceType, state);

      y.description = `${logisticName} ${productTypeName} ${shippingServiceName}`;
    });
  });
}

export const orderAutomatizationModalUtils = {
  fillProductsLocalization,
};
